import { NGhostProducts } from '@df/module-ghost-products/ghost-products.namespace';
export function addOnsGhostProdctRulesFilter(rule: NGhostProducts.IOfferPrepared) {
    return rule?.ruleType?.toLowerCase() === 'add-ons';
}
